import { useState, useEffect } from 'react';
import { getColorConfigsByProperty } from '../Api';

const useActiveColorConfig = (propertyId, buildingName) => {
  const [activeConfig, setActiveConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      if (!propertyId) {
        setError('Property ID is required');
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const params = {};
        if (buildingName) params.building_name = buildingName;
        const { activeConfig } = await getColorConfigsByProperty(propertyId, params);
        setActiveConfig(activeConfig);
      } catch (err) {
        setError(err.message || 'Error fetching active config');
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, [propertyId, buildingName]);

  return { activeConfig, isLoading, error };
};

export { useActiveColorConfig };
